module.exports = {
      id: "search-usage",
      viewBox: "0 0 16 17",
      url: __webpack_public_path__ + "img/icons.bfe893b5.svg#search-usage",
      toString: function () {
        return this.url;
      }
    }